import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ModalService } from '../../modal/modal.service';
import { SupportService } from '../../support.service';
import { SupportCreateTicketModalComponent } from '../support-create-ticket-modal/support-create-ticket-modal.component';
import { SupportTicketViewModalComponent } from '../support-ticket-view-modal/support-ticket-view-modal.component';
import { SupportTicket } from '@models/support-ticket.interface';
import { ModalBoxComponent } from '@shared/modal-box/modal-box.component';
import { SessionService } from '@shared/session.service';

@Component({
  selector: 'app-support-my-tickets-modal',
  templateUrl: './support-my-tickets-modal.component.html',
  styleUrls: ['./support-my-tickets-modal.component.scss'],
  imports: [ModalBoxComponent, RouterLink, DatePipe],
})
export class SupportMyTicketsModalComponent implements OnInit {
  constructor(private modalService: ModalService, public supportService: SupportService, public session: SessionService) {}

  async ngOnInit(): Promise<void> {
    await this.supportService.getTickets();
  }

  viewTicket(ticket: SupportTicket) {
    this.supportService.currentTicket = ticket;
    this.supportService.currentTicketMessages = [];
    this.modalService.open(SupportTicketViewModalComponent, ticket.id);
  }

  openCreateTicket() {
    this.modalService.open(SupportCreateTicketModalComponent, null, { requiresAuth: true });
  }

  closeModal() {
    this.modalService.close();
  }
}
